import { useState } from 'react';
import fetchAPI from 'app/helpers/fetch';
import type { Values } from './types';

const useFormSubmit = (values: Values): [() => void, boolean, string] => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const submit = () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    setError('');

    fetchAPI('/players/quick_sign_up', {
      method: 'POST',
      body: JSON.stringify({ player: values }),
    }).catch((err: string) => {
      setError(err);
      setIsSubmitting(false);
    });
  };

  return [submit, isSubmitting, error];
};

export default useFormSubmit;
